import SidePanelHeader from "../components/SidePanelHeader"
import SidePanelBreadCrumb from "../components/SidePanelBreadCrumb"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelNonSensitiveInfo from "../components/SidePanelNonSensitiveInfo"
import { httpGet, httpPost } from "../../../../../modules/Backend"
import { useEffect, useState } from "react"
import { EntityNames } from "../../../../../enums/EntityNames";
import PrintOuterCubeLabel from "../../../print/PrintOuterCubeLabel";
import { globalSubmittingSignal } from "../../Layout";
import { Button } from "react-aria-components";
import { modalSignal } from "../../../Modal/ModalContainer";
import ConfirmModal, { ConfirmType } from "../../../Modal/ConfirmModal";
import { HttpStatusCode } from "axios";
import { useSignals } from "@preact/signals-react/runtime";
import SidePanelOuterCubeMaterial from "../components/SidePanelOuterCubeMaterial";
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext";

export default function SidePanelWorkstationOuterCube({ data, onViewPage }: any) {
    useSignals();

    const navigate = useNavigate()
    const permissionsContext = usePermissions();
    const [location, setLocation] = useState<string>("")

    function viewEntity() {
        Navigation.view.navigate(navigate, EntityNames.outerCubes, data.id, data)
    }

    async function getLocation() {
        const result = await httpGet(`api/outerCubes/location?id=${data.id}`)
        if (result?.data?.breadcrumb) {
            setLocation(result.data.breadcrumb)
        }
    }

    async function deleteOuterCube() {
        const payload = {
            id: data.id
        };
        const result = await httpPost(`api/outerCubes/delete`, payload);
        if (result.status === HttpStatusCode.Ok) {
            if (onViewPage) {
                navigate(-1);
            } else {
                window.location.reload();
            }
        }
    }

    function handleDeleteOuterCube() {
        modalSignal.value = <ConfirmModal heading={`Delete outer cube?`}
            information="This action cannot be undone"
            ContinueFunc={deleteOuterCube}
            type={ConfirmType.Destructive} />
    }

    useEffect(() => {
        data.currentLocation ? setLocation(data.currentLocation) : getLocation()
    }, [data])

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="Pack Into Pallet" value={data.reference} statuses={data.status} onClick={(() => { viewEntity() })} />}
                <div className="display--flex flex__wrap--wrap margin__top--s justifyContent--space-between">
                    <div className="display--flex gap--s">
                        <PrintOuterCubeLabel outerCubeId={data.id} />
                    </div>
                    <div className="display--flex">
                        {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Delete_Outer_Cube) &&
                            <Button isDisabled={globalSubmittingSignal.value.isBusy} className={"button button--small button--primary button--secondary--destructive button--with-icon"} onPress={handleDeleteOuterCube}>
                                <p className="button-text">Delete</p>
                            </Button>
                        }
                    </div>
                </div>
                <SidePanelBreadCrumb descriptor="Current Location" value={location} />
                <SidePanelOuterCubeMaterial data={data} />
                <SidePanelNonSensitiveInfo descriptor="Notes" data={{ id: data.id, entityName: EntityNames.outerCubes }} dataTarget="notes" />
            </>
        }
    </>)
}